export interface VulnerabilityPackage {
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  ecosystem: 'MAVEN' | 'NPM' | 'NUGET' | 'PIP' | 'RUBYGEMS' | string;
  name: string;
}
export interface SecurityVulnerability {
  firstPatchedVersion?: { identifier: string };
  package: VulnerabilityPackage;
  vulnerableVersionRange: string;
}
export interface SecurityAdvisory {
  description?: string;
  identifiers?: { type: string; value: string }[];
  references: { url: string }[];
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  severity: 'HIGH' | 'MODERATE' | string;
}
export interface VulnerabilityAlert {
  dismissReason?: string | null;
  securityAdvisory: SecurityAdvisory;
  securityVulnerability: SecurityVulnerability;
  vulnerableManifestFilename: string;
  vulnerableManifestPath: string;
  vulnerableRequirements?: string;
}
